// extracted by mini-css-extract-plugin
export var component = "HeaderHelpMenu-module--component--yDGtD";
export var icon = "HeaderHelpMenu-module--icon--+eWjH";
export var link = "HeaderHelpMenu-module--link--aMTnq";
export var list = "HeaderHelpMenu-module--list--g+3bo";